var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn printer-calibration-button",attrs:{"hidden":_vm.toggle.printerPlugin},on:{"click":function($event){return _vm.open()}}},[_c('md-tooltip',[_vm._v("Calibrar impressora")]),_vm._v(" "),_c('md-icon',{attrs:{"md-src":"/static/images/icon-printer-calibration.svg"}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }